<div class="contformLogin">
  <h1>MY POSVENTA</h1>
  <h2>Bienvenido</h2>
  <form [formGroup]="loginform" (ngSubmit)="login()">
    <div class="form-group mb-3">
      <input placeholder="Usuario" formControlName="username" class="form-control form-control-lg inputLogin" />
      <label class="error" *ngIf="loginform.get('username').errors?.required">*Este campo es obligatorio.</label>
    </div>
    <div class="form-group mb-3">
      <input placeholder="Contraseña" formControlName="password" type="password"
        class="form-control form-control-lg inputLogin" />
      <label class="error" *ngIf="loginform.get('password').errors?.required">*Este campo es obligatorio.</label>
    </div>
    <input type="submit" class="btn btn-primary" value="Entrar">
  </form>
</div>